import { Layout } from '@/data/types/Layout';

export const getElementsLandingsPage = (): Layout => ({
	name: 'HomeStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'ElementsLandings', id: 'elements-landings-page'}],
		second: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
